// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__sVq9l","textTitle":"Text_textTitle__gRdRF","textContent":"Text_textContent__MGbtE","fadeIn":"Text_fadeIn__FrAUL"};